import { useState, useEffect, useContext, createContext } from 'react';
import api from '../api/API';
import { limparTokenDoServiceWorker } from '../services/pushClient';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    const token = localStorage.getItem('authToken');

    if (storedUser && token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        const isExpired = payload.exp && payload.exp * 1000 < Date.now();

        if (isExpired) {
          localStorage.removeItem('authToken');
          localStorage.removeItem('user');
          localStorage.removeItem('selectedWorkspaceId');
          setUser(null);
          setIsAuthenticated(false);
        } else {
          setUser(JSON.parse(storedUser));
          setIsAuthenticated(true);
        }
      } catch {
        localStorage.removeItem('authToken');
        localStorage.removeItem('user');
        setUser(null);
        setIsAuthenticated(false);
      }
    } else {
      setUser(null);
      setIsAuthenticated(false);
    }

    setLoading(false);
  }, []);

  const login = async (email, senha) => {
    try 
    {
      const response = await api.post('/user/login', { email, senha });
      const { token, user } = response.data;

      localStorage.setItem('authToken', token);
      localStorage.setItem('user', JSON.stringify(user));

      setUser(user);
      setIsAuthenticated(true);
      return { success: true };
    } 
    catch (error) 
    {
      console.error('Erro no login:', error);
      return { success: false, message: 'Credenciais inválidas.' };
    }
  };


  const logout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
    localStorage.removeItem('selectedWorkspaceId');
    // O service worker guarda uma copia do JWT no Cache API para as acoes das
    // notificacoes; sem limpar aqui ela sobreviveria ao logout.
    limparTokenDoServiceWorker();
    setUser(null);
    setIsAuthenticated(false);
    // window.location.href = '/login';
  };
/*
  const value = {
    user,
    loading,
    isAuthenticated,
    login,
    logout,
  };
*/
  // return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;

  return (
    <AuthContext.Provider value={{ user, loading, isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );


};

export const useAuth = () => {
  return useContext(AuthContext);
};
